import NextLink from "next/link"
import cn from "classnames"
import getTarget from "utilities/getTarget"
import LoadingIco from 'public/assets/loading.svg'

export default function CallToAction({
  href,
  target = null,
  children,
  style = "primary",
  button = false,
  download = false,
  loading = false,
  className,
  title = null,
  onClick,
  disabled = false
}) {
  const styles = cn(
    "inline-block cursor-pointer max-w-full transition-all duration-300", // default styles
    `${style}-link`,
    className,
  )

  if (button) {
    return (
      <button className={cn(styles, {
        "relative text-transparent": loading
      })} title={title} onClick={onClick} disabled={disabled}>
        {children}
        {loading && <LoadingIco width="40" height="40" className="text-secondary absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />}
      </button>
    )
  }

  if (!href)
    return (
      <span data-type="invalid-link" className={styles}>
        {children}
      </span>
    )

  const targetValue = target ?? getTarget(href)

  return targetValue === "_self" ? (
    <NextLink
      href={href}
      data-type="route"
      target="_self"
      title={title}
      download={download}
      className={styles}
      onClick={onClick}
    >
      {children}
    </NextLink>
  ) : (
    <a
      data-type="external"
      className={styles}
      target={targetValue}
      title={title}
      download={download}
      href={href}
      onClick={onClick}
    >
      {children}
    </a>
  )
}
